<DOMContainer width="100%" height="100%" controls={controls}>
    <div class="rpg-ui-menu-panel rpg-ui-panel">
        <div class="rpg-ui-menu-panel-header">{t("rpg.menu.exit")}</div>
        <div class="rpg-ui-menu-panel-body">
            <div class="rpg-ui-menu-panel-details">
                <div class="rpg-ui-menu-panel-details-title">{t("rpg.menu.leave-game")}</div>
                <div class="rpg-ui-menu-panel-details-desc">
                    {t("rpg.menu.exit-help")}
                </div>
            </div>
        </div>
    </div>
</DOMContainer>

<script>
    import { signal } from "canvasengine";
    import { inject } from "../../../core/inject";
    import { RpgClientEngine } from "../../../RpgClientEngine";
    import { getKeyboardControlBind } from "../../../services/actionInput";
    import { menuGamepadControls } from "../../../services/gamepadControls";

    const engine = inject(RpgClientEngine);
    const { t } = engine.i18n();
    const keyboardControls = engine.globalConfig.keyboardControls;
    const { onConfirm, onBack } = defineProps();

    const controls = signal({
        action: {
            bind: getKeyboardControlBind(keyboardControls.action),
            keyDown() {
                if (onConfirm) onConfirm();
            }
        },
        escape: {
            bind: keyboardControls.escape,
            keyDown() {
                if (onBack) onBack();
            }
        },
        gamepad: menuGamepadControls
    });
</script>
